/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import type {
  EntWebsiteBlockPdfViewerQuery,
  EntWebsitePdfViewerFragment,
} from 'bundles/ent-website/__generated__/contentfulTypes';
import PdfViewer from 'bundles/ent-website/components/PdfViewer';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import BlockLayout from 'bundles/ent-website/contentful/core/BlockLayout';
import { entWebsiteBlockPdfViewerQuery } from 'bundles/ent-website/queries/EntWebsitePdfViewer';
import withBlockQuery from 'bundles/ent-website/utils/withBlockQuery';
import type { BlockModuleInnerProps } from 'bundles/ent-website/utils/withBlockQuery';

type Props = BlockModuleInnerProps<EntWebsitePdfViewerFragment>;

export function PdfViewerModule({ content, assembly }: Props) {
  const styles = {
    error: css`
      background-color: var(--cds-color-red-50);
      color: var(--cds-color-white-0);
      font-size: 24px;
      padding: var(--cds-spacing-200);
    `,
  };
  const pdfUrl = content.fileAttachment?.url;

  const contentPanel = () => {
    if (!pdfUrl) {
      return <div css={styles.error}>No PDF file found</div>;
    }

    return <div>{Boolean(pdfUrl) && <PdfViewer url={pdfUrl} />}</div>;
  };

  return <BlockLayout assembly={assembly} renderContent={contentPanel} />;
}

// @ts-expect-error TSMIGRATION-5.0 TS2344
export const BlockPdfViewer = withBlockQuery<EntWebsitePdfViewerFragment, EntWebsiteBlockPdfViewerQuery>(
  entWebsiteBlockPdfViewerQuery
)(PdfViewerModule);
